<template>
  <div
    v-if="devWarning"
    class="p-1 bg-nash-mustard600 font-semibold text-center print:hidden"
  >
    {{ devWarning }}
  </div>
  <div
    v-if="productWarningConfig?.message"
    data-testid="app-banner"
    :class="`flex justify-center p-2 ${productWarningConfig?.styles} font-semibold print:hidden relative`"
  >
    <TIcon :icon="productWarningConfig?.icon"></TIcon>
    <div class="ml-2">
      {{ productWarningConfig?.message }}
    </div>
  </div>
</template>

<script lang="ts">
import TIcon from '@thyme/nashville/src/components/icon/TIcon.vue'
import { defineComponent } from 'vue'
import { setup } from './controller'

export default defineComponent({
  components: {
    TIcon,
  },
  setup,
})
</script>
